<!-- <div class="d-flex flex-column sticky-footer-wrapper min-vh-100">
    <app-header ></app-header>
    <app-tabs></app-tabs>
     <app-footer></app-footer>
</div> -->
<!-- <app-home></app-home> -->
<router-outlet></router-outlet>
